<template>
  <Drawer
    class="drawer_modal"
    width="700"
    v-model="showDrawer"
  >
    <moneyOrderDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></moneyOrderDetail>

    <moneyOrderForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></moneyOrderForm>

    <moneyOrderFormTransfer
      v-if="showCreateTransferComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></moneyOrderFormTransfer>
  </Drawer>
</template>

<script>
import { BaseItemData } from "../../base/base_item.js";

import moneyOrderForm from "@/apps/money_order/moneyOrderForm.vue";
import moneyOrderDetail from "@/apps/money_order/moneyOrderDetail.vue";
import moneyOrderFormTransfer from "@/apps/money_order/moneyOrderFormTransfer.vue";

let _app = BaseItemData();
_app.components = {
  moneyOrderDetail,
  moneyOrderForm,
  moneyOrderFormTransfer
};
_app.data = function() {
  return {
    titles: {
      detail: "Документ",
      edit: "Редактирование документа",
      create: "Создание документа",
      create_transfer: "Создание документа",
    },
    itemAction: "detail",
    itemId: "",
    showDrawer: false
  };
};
_app.computed.showCreateTransferComponent = function () {
  return this.showDrawer && this.itemAction === 'create_transfer'
};
// _app.methods.showCreateTransfer = function () {
//   this.itemAction = 'create_transfer';
//   // this.$router.push({name: this.item_type + '_create'});
// };
_app.watch.show_drawer = function (newValue, oldValue) {
  this.showDrawer = newValue;
  this.itemAction = this.action;
  this.itemId = this.id;

  if (newValue) {
    if (this.itemAction === 'detail') {
      this.showDetail(this.itemId);
    } else if (this.itemAction === 'edit') {
      this.showEdit(this.itemId);
    } else if (this.itemAction === 'create') {
      this.showCreate();
    } else if (this.itemAction === 'create_transfer') {
      // this.showCreateTransfer();
      //console.log(111111111111)
    }
  } else {
    this.detail = {};
    this.formData = {};
    //this.$router.go(-1);
    this.$router.push({name: this.item_type});
  }

};

export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/money_order/moneyOrderItem.vue